import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["challenge"],
    _excluded2 = ["challenge"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { borderRadius } from '@infl-ts/ui-advocate-theme';
import { useEmbedMode } from '@infl-ts/util-embed-mode-provider';
import { useToggle } from '@infl-ts/util-hooks';
import { attachScheme } from '@infl-ts/util-url';
import { includesPermission, isActualAdmin, Permission, useAdminPermissions } from '@infl-ts/util-use-admin-permissions';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, IconButton, SwipeableDrawer, useMediaQuery } from '@mui/material';
import { flow, pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import { Translation } from 'react-i18next';
import { DrawerPuller } from '../drawer-puller';
import { Popover } from '../popover';
import { Tooltip } from '../tooltip';
import AdminActions from './admin-actions';
import SaveForLater from './save-for-later';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var hasDismissedActivity = function hasDismissedActivity(activities) {
  return activities.some(function (a) {
    return a.state === 'dismissed';
  });
};

var useCorporateAccessPermission = function useCorporateAccessPermission(profile, jwt, currentHubURL) {
  return pipe(useAdminPermissions(profile, jwt, currentHubURL), O.exists(includesPermission(Permission.map.CorporateAccess)));
};

var AncillaryButton = function AncillaryButton(_ref) {
  var onClick = _ref.onClick,
      _ref$showAncillaryAct = _ref.showAncillaryActions,
      showAncillaryActions = _ref$showAncillaryAct === void 0 ? true : _ref$showAncillaryAct;
  return /*#__PURE__*/_jsx(Translation, {
    "data-element": "Translation",
    "data-component": "AncillaryButton",
    "data-source-file": "challenge-ancillary-actions.tsx",
    children: function children(t) {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: t('More Options'),
        children: /*#__PURE__*/_jsx(IconButton, {
          sx: {
            zIndex: function zIndex(t) {
              return t.zIndex._2;
            },
            opacity: showAncillaryActions ? 1 : 0,
            '&:focus': {
              opacity: 1
            }
          },
          onClick: onClick,
          children: /*#__PURE__*/_jsx(MoreVertIcon, {})
        })
      });
    }
  });
};

var DrawerAncillaryMenu = function DrawerAncillaryMenu(_ref2) {
  var challenge = _ref2.challenge,
      props = _objectWithoutProperties(_ref2, _excluded);

  var _useToggle = useToggle(),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      isOpen = _useToggle2[0],
      _useToggle2$ = _useToggle2[1],
      open = _useToggle2$.on,
      close = _useToggle2$.off;

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(AncillaryButton, {
      onClick: open,
      "data-element": "AncillaryButton",
      "data-component": "DrawerAncillaryMenu",
      "data-source-file": "challenge-ancillary-actions.tsx"
    }), /*#__PURE__*/_jsx(SwipeableDrawer, {
      PaperProps: {
        sx: {
          borderTopLeftRadius: function borderTopLeftRadius(t) {
            return borderRadius(t);
          },
          borderTopRightRadius: function borderTopRightRadius(t) {
            return borderRadius(t);
          }
        }
      },
      anchor: "bottom",
      open: isOpen,
      onClose: close,
      onOpen: open,
      disablePortal: true,
      disableDiscovery: true,
      "data-element": "SwipeableDrawer",
      "data-source-file": "challenge-ancillary-actions.tsx",
      children: /*#__PURE__*/_jsxs(Box, {
        sx: {
          mb: 2
        },
        "data-element": "Box",
        "data-source-file": "challenge-ancillary-actions.tsx",
        children: [/*#__PURE__*/_jsx(DrawerPuller, {
          "data-element": "DrawerPuller",
          "data-source-file": "challenge-ancillary-actions.tsx"
        }), props.hideSaveForLater ? null : /*#__PURE__*/_jsx(SaveForLater, _objectSpread(_objectSpread({}, props), {}, {
          challenge: challenge
        })), /*#__PURE__*/_jsx(AdminActions, _objectSpread(_objectSpread({}, props), {}, {
          challengeId: challenge.id,
          "data-element": "AdminActions",
          "data-source-file": "challenge-ancillary-actions.tsx"
        }))]
      })
    })]
  });
};

var PopoverAncillaryMenu = function PopoverAncillaryMenu(_ref3) {
  var challenge = _ref3.challenge,
      props = _objectWithoutProperties(_ref3, _excluded2);

  return /*#__PURE__*/_jsx(Popover, {
    noPadding: true,
    zIndex: props.zIndex ? props.zIndex : function (t) {
      return t.zIndex.popover;
    },
    content: function content() {
      return /*#__PURE__*/_jsxs(Box, {
        tabIndex: -1,
        sx: {
          display: 'flex',
          flexDirection: 'column',
          minWidth: 148
        },
        children: [props.hideSaveForLater ? null : /*#__PURE__*/_jsx(SaveForLater, _objectSpread(_objectSpread({}, props), {}, {
          challenge: challenge
        })), /*#__PURE__*/_jsx(AdminActions, _objectSpread(_objectSpread({}, props), {}, {
          challengeId: challenge.id
        }))]
      });
    },
    "data-element": "Popover",
    "data-component": "PopoverAncillaryMenu",
    "data-source-file": "challenge-ancillary-actions.tsx",
    children: /*#__PURE__*/_jsx(AncillaryButton, {
      showAncillaryActions: props.showAncillaryActions,
      "data-element": "AncillaryButton",
      "data-component": "PopoverAncillaryMenu",
      "data-source-file": "challenge-ancillary-actions.tsx"
    })
  });
};

var AncillaryActions = function AncillaryActions(props) {
  var isMobile = useMediaQuery(function (theme) {
    return theme.breakpoints.down('md');
  });
  if ((props.hasBeenDismissedAlready || props.hideSaveForLater) && !props.isCorporateAdmin) return null;
  return isMobile ? /*#__PURE__*/_jsx(DrawerAncillaryMenu, _objectSpread(_objectSpread({}, props), {}, {
    hasBeenDismissedAlready: props.hasBeenDismissedAlready,
    isCorporateAdmin: props.isCorporateAdmin
  })) : /*#__PURE__*/_jsx(PopoverAncillaryMenu, _objectSpread(_objectSpread({}, props), {}, {
    hasBeenDismissedAlready: props.hasBeenDismissedAlready,
    isCorporateAdmin: props.isCorporateAdmin
  }));
};

var useProps = function useProps(props) {
  var isMobile = useMediaQuery(function (theme) {
    return theme.breakpoints.down('md');
  });

  var _useEmbedMode = useEmbedMode(),
      jwt = _useEmbedMode.jwt,
      host = _useEmbedMode.host;

  var currentHubURL = host ? attachScheme(host) : undefined;
  var hasCorporateAccess = useCorporateAccessPermission(props.profile, jwt, currentHubURL);
  return _objectSpread({
    isMobile: isMobile,
    hasCorporateAccess: hasCorporateAccess,
    isCorporateAdmin: props.profile && isActualAdmin(props.profile) && hasCorporateAccess,
    hideSaveForLater: props.challenge.savedForLater,
    hasBeenDismissedAlready: props.challenge.activities && hasDismissedActivity(props.challenge.activities)
  }, props);
};

export default Object.assign(flow(useProps, AncillaryActions), {
  displayName: 'AncillaryActions'
});